import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';
import useMixpanel from '../../../../hooks/useMixpanel';
import useRtmEventsService from '../../ClinicalEvents/service';
import { LoadingPlaceholder } from '../../../../components/LoadingPlaceholder';
import { isEmpty } from 'lodash';
import { ClinicalEventsHeader } from '../../ClinicalEvents/ClinicalEventsHeader';
import EventsList from '../../ClinicalEvents/EventsList';
import EmptyEvents from '../../ClinicalEvents/EmptyEvents';
import ClinicalEventModalProvider from '../../ClinicalEvents/Drawer/Provider';
import MobileClinicalEventModal from './Drawer';
import classNames from 'classnames';
import eventStyles from '../../ClinicalEvents/index.module.scss';
import { Button } from '@mui/material';
import { ReactComponent as SortArrow } from '../../../../assets/icons/arrowDownwardIcon.svg';
import styles from '../index.module.scss';
import useIsPrimaryTheme from '../../../../hooks/useIsPrimaryTheme';

function MobileReportedEvents() {
  const isPrimaryTheme = useIsPrimaryTheme();
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  useMixpanel({ screen: 'mobile_new_reported_events', patientUuid });
  const [eventUuid, setEventUuid] = useState<string>('');
  const [isSortedDesc, setSortedDesc] = useState<boolean>(true);

  const { data, isLoading, isError } = useRtmEventsService(patientUuid);

  if (isError) {
    return null;
  }

  return (
    <LoadingPlaceholder isLoading={isLoading}>
      <ClinicalEventModalProvider>
        <div
          className={classNames(eventStyles.root, 'w-full', {
            [eventStyles.primaryP3Main]: isPrimaryTheme,
            [eventStyles.empty]: isEmpty(data),
          })}
        >
          <div
            className={classNames('flex flex-col', styles.headerWrapper, {
              ['mb-2']: data?.length > 1,
            })}
          >
            <ClinicalEventsHeader isEmptyEvents={isEmpty(data)} title="Clinical events" />
            {data?.length > 1 ? (
              <Button
                type="submit"
                variant="text"
                onClick={() => setSortedDesc(!isSortedDesc)}
                className={classNames(
                  'color-disabled text-xs p-0 justify-start',
                  styles.sortBtn,
                )}
              >
                Sorted by creation date
                <SortArrow
                  className={classNames(styles.sortIcon, {
                    [styles.rotate]: !isSortedDesc,
                  })}
                />
              </Button>
            ) : null}
          </div>
          {!isEmpty(data) ? (
            <EventsList
              onChange={(uuid) => setEventUuid(uuid)}
              uuid={eventUuid}
              sortType={isSortedDesc ? 'desc' : 'asc'}
            />
          ) : (
            <EmptyEvents />
          )}
        </div>
        <MobileClinicalEventModal onChange={(uuid) => setEventUuid(uuid)} uuid={eventUuid} />
      </ClinicalEventModalProvider>
    </LoadingPlaceholder>
  );
}
export default observer(MobileReportedEvents);
